// Component Libraries
import { useNavigate } from "react-router-dom";

// Context
import { useUser } from "../../../model/contexts/user.context";

//Design Libraries
import "./SideBar.scss";

const SideBar = () => {
  const navigate = useNavigate();
  const { logoutUser } = useUser();

  const handleSignOut = async () => {
    try {
      await logoutUser();
      navigate("/auth");
    } catch (error) {
      console.error("Sign out error:", error);
      alert("Failed to sign out.");
    }
  };

  return (
    <div id="sidebar-outer-container">
      <div className="menu-outer-container">
        <div className="menu-text">
          <a
            className="menu-link-text"
            onClick={() => navigate("/project-dashboard")}
          >
            My Workspace
          </a>
        </div>
        <div className="menu-text">
          <a
            className="menu-link-text"
            onClick={() => navigate("/template-dashboard")}
          >
            Templates
          </a>
        </div>
        <div className="menu-text">
          <a className="menu-link-text" onClick={() => navigate("/settings")}>
            Settings
          </a>
        </div>
        <div className="menu-text">
          <a className="menu-link-text" onClick={() => navigate("/billing")}>
            Billing
          </a>
        </div>
      </div>

      <button className="sign-out-button" onClick={handleSignOut}>
        Sign Out
      </button>
    </div>
  );
};

export default SideBar;
